import { ReactElement } from 'react'
import styled from 'styled-components'
import { Close } from '@mui/icons-material'

import { I18n, Translate } from 'common'
import { MessageBoxType } from '../Interfaces'

interface MessageTitleProps {
  titleText: string
  titleReplacement?: Array<string | number>
  titleSubText?: string
  closeText: string
  onClose: () => void
  type: MessageBoxType
}

export const MessageBoxTitleBar = (props: MessageTitleProps): ReactElement => {
  const {
    titleText,
    titleReplacement,
    titleSubText,
    closeText,
    onClose,
    type,
  } = props
  const isErrorTypeOfUnavaliabilty = MessageBoxType.ERROR === type
  return (
    <MessagesHeader isErrorTypeOfUnavaliabilty={isErrorTypeOfUnavaliabilty}>
      <MessagesHeaderTitle>
        {isErrorTypeOfUnavaliabilty ? (
          <span
            className="material-icons md-dark text-danger"
            style={{ marginRight: '10px' }}
          >
            error
          </span>
        ) : (
          <span
            className="material-icons md-dark text-warning"
            style={{ marginRight: '10px' }}
          >
            warning
          </span>
        )}
        {Translate(titleText, titleReplacement)}
        {titleSubText && (
          <I18n
            name={titleSubText}
            style={{ marginLeft: '0.5rem', fontWeight: 'normal' }}
          />
        )}
      </MessagesHeaderTitle>
      <DismissButton onClick={onClose}>
        <CloseIcon /> {Translate(closeText)}
      </DismissButton>
    </MessagesHeader>
  )
}

interface MessagesHeaderProps {
  isErrorTypeOfUnavaliabilty: boolean
}

const MessagesHeader = styled.div<MessagesHeaderProps>`
  display: flex;
  justify-content: space-between;
  background: ${(p) =>
    p.isErrorTypeOfUnavaliabilty
      ? p.theme.colors.dangerAlertBg
      : p.theme.colors.shoppingCartMessageHeader};
  height: 48px;
  padding: 0.7rem;
`
const MessagesHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${(p) => p.theme.colors.almostBlack};
`
const DismissButton = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  cursor: pointer;
`

const CloseIcon = styled(Close)`
  width: 16px;
  height: 16px;
`
